if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.limitedProductsHandles = ['measure-stress', 'hey-freya-annual-membership'];
        document.addEventListener("DOMContentLoaded", () => {
          this.initDateFields();
          this.checkPhoneFields();
        });
      }

      clearLoadingState() {
        this.submitButton.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loading-overlay__spinner").classList.add(
          "hidden",
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        if (!this.validateProperties()) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden",
        );

        // Add MEASURE STRESS TEST only one times
        fetch('/cart.js')
        .then((response) => response.json())
        .then((data) => {    
          if (data.items.length) {
            const productHandleInForm = this.form.getAttribute('data-product-handle');
            const isLimitedProductInForm = this.limitedProductsHandles.includes(productHandleInForm);
            const limitedProductHandleInCart = [...data.items].find((item) => this.limitedProductsHandles.includes(item.handle))?.handle;

            if (limitedProductHandleInCart && productHandleInForm === limitedProductHandleInCart) {
              const limitedProductErrorMessage = this.form.getAttribute('data-product-limit-message');

              this.handleErrorMessage(limitedProductErrorMessage);
              this.clearLoadingState();
              return;
            } else if (limitedProductHandleInCart && isLimitedProductInForm && productHandleInForm !== limitedProductHandleInCart) {
              const relatedLimitedProductErrorMessage = this.form.getAttribute('data-related-product-limit-message');

              this.handleErrorMessage(relatedLimitedProductErrorMessage);
              this.clearLoadingState();
              return;
            } else {
              this.addProductToCart();
              return;
            }
          }

          this.addProductToCart();
        })
        .catch((e) => {
          console.error(e);
          this.clearLoadingState();
        })
      }

      addProductToCart() {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => this.clearLoadingState());
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      validateProperties() {
        const properties = document.querySelectorAll(
          '[data-product-property="true"]',
        );

        let results = true;

        properties.forEach((input) => {
          if (!results) {
            return;
          }

          if (!input) {
            this.handleErrorMessage(
              "Development Error in the input component.",
            );
            results = false;

            return;
          }

          if (input.required) {
            if (input.getAttribute("type") === "radio") {
              const checkedEl = document.querySelector(
                `[name="${input.getAttribute("name")}"]:checked`,
              );

              if (!checkedEl) {
                this.handleErrorMessage(
                  input.getAttribute("data-required-message") ||
                    "This field is required.",
                );
                results = false;

                return;
              }
            } else {
              if (!String(input.value).trim()) {
                this.handleErrorMessage(
                  input.getAttribute("data-required-message") ||
                    "This field is required.",
                );
                results = false;

                return;
              }
            }
          }

          if (input.pattern) {
            if (!new RegExp(input.pattern).test(String(input.value).trim())) {
              this.handleErrorMessage(
                input.getAttribute("data-pattern-message") ||
                  "This field has invalid format.",
              );
              results = false;

              return;
            }

            // special case for date fields validate
            if (input.hasAttribute("data-check-date")) {
              const year = Number(input.value.split("/").pop());
              const currentYear = new Date().getFullYear();

              // Calculate the minimum valid year (current year minus 18)
              const maxYear = currentYear - 18;
              const minYear = currentYear - 100;

              if (year > maxYear || year < minYear) {
                this.handleErrorMessage(
                  input.getAttribute("data-pattern-message") ||
                    "This field has invalid format.",
                );

                results = false;

                return;
              }
            }
          }

          const isCheckedRadioInput = input.getAttribute("type") === "radio" && input.checked;
          const isNotRadioInput = input.getAttribute("type") !== "radio";

          if (isNotRadioInput && input.value || isCheckedRadioInput) {
            const formInput = this.form.querySelector(
              `input[name="${input.getAttribute("name")}"]`,
            );
            if (!formInput) {
              const hiddenInput = document.createElement("input");
              hiddenInput.type = "hidden";
              hiddenInput.name = input.getAttribute("name");
              hiddenInput.value = input.value;
              this.form.appendChild(hiddenInput);
            } else {
              formInput.value = input.value;
            }
          }
        });

        return results;
      }
      initDateFields() {
        document
          .querySelectorAll(".field__input[data-check-date]").forEach((field) => {
            if (Datepicker) {
              new Datepicker(field, {
                format: 'mm/dd/yyyy',
                buttonClass: 'datepicker-button',
              });
            }
          })
      }
      checkDateFields() {
        function checkValue(str, max, min = 1) {
          if (str.charAt(0) !== "0" || str == "00") {
            var num = parseInt(str);
            if (isNaN(num) || num <= 0 || num > max) num = min;
            str =
              num > parseInt(max.toString().charAt(0)) &&
              num.toString().length == 1
                ? "0" + num
                : num.toString();
          }
          return str;
        }

        function checkYearValue(str, min) {
          if (str.charAt(0) !== "0" || str == "00") {
            var num = parseInt(str);
            if (isNaN(num) || num <= 0) num = 1;
            str = num.toString();
          }
          return str;
        }

        document
          .querySelectorAll(".field__input[data-check-date]")
          .forEach(function (date) {
            date.addEventListener("input", function (e) {
              this.type = "text";
              var input = this.value;
              if (/\D\/$/.test(input))
                input = input.substr(0, input.length - 3);
              var values = input.split("/").map(function (v) {
                return v.replace(/\D/g, "");
              });
              if (values[0]) values[0] = checkValue(values[0], 12);
              if (values[1]) values[1] = checkValue(values[1], 31);
              var output = values.map(function (v, i) {
                return v.length == 2 && i < 2 ? v + "/" : v;
              });
              this.value = output.join("").substr(0, 10);
            });

            date.addEventListener("blur", function (e) {
              this.type = "text";
              var input = this.value;
              var values = input.split("/").map(function (v, i) {
                return v.replace(/\D/g, "");
              });
              var output = "";

              if (values.length == 3) {
                var year =
                  values[2].length !== 4
                    ? parseInt(values[2]) + 2000
                    : parseInt(values[2]);
                var month = parseInt(values[0]) - 1;
                var day = parseInt(values[1]);
                var d = new Date(year, month, day);
                if (!isNaN(d)) {
                  var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
                  output = dates
                    .map(function (v) {
                      v = v.toString();
                      return v.length == 1 ? "0" + v : v;
                    })
                    .join("/");
                }
              }
              this.value = output;
            });
          });
      }
      checkPhoneFields() {
        document
          .querySelectorAll(".field__input[data-check-phone]")
          .forEach(function (field) {
            field.addEventListener("input", function (e) {
              var x = e.target.value
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
              e.target.value = !x[2]
                ? x[1]
                : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
            });
          });
      }
    },
  );
}
